enum ActionType {
    REQUEST_MONA_ENGINE_MODES = '[MONA ENGINE MODES] REQUEST DATA',
    RECEIVED_MONA_ENGINE_MODES = '[MONA ENGINE MODES] RECEIVE DATA',
}

export default ActionType
